import React, { useState } from "react";
import { Copy, CheckCircle2, X, Wallet } from "lucide-react";
import { toast } from "sonner";
import { BRAND } from "../../constants/brand";

export default function UPIPaymentModal({ open, onClose, amount = 0, orderRef = "" }) {
  const [copied, setCopied] = useState(false);
  if (!open) return null;

  const copyUpi = async () => {
    try {
      await navigator.clipboard.writeText(BRAND.upi.id);
      setCopied(true);
      toast.success("UPI ID copied");
      setTimeout(() => setCopied(false), 1500);
    } catch { toast.error("Couldn't copy"); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4" onClick={onClose} data-testid="upi-modal-backdrop">
      <div className="relative w-full max-w-md rounded-xl border border-neutral-200 bg-white p-6 shadow-2xl" onClick={(e) => e.stopPropagation()} data-testid="upi-modal">
        <button onClick={onClose} className="absolute right-4 top-4 rounded-full p-1 text-neutral-400 hover:bg-neutral-100 hover:text-neutral-900" aria-label="Close" data-testid="upi-modal-close">
          <X size={18} />
        </button>

        <div className="flex items-center gap-2">
          <Wallet size={20} className="text-lime-500" />
          <h3 className="font-display text-lg font-bold">Pay via UPI</h3>
        </div>
        <p className="mt-1 text-sm text-neutral-600">Scan the QR from any UPI app or copy the UPI ID.</p>

        {amount > 0 && (
          <div className="mt-3 flex items-center justify-between rounded-md border border-neutral-200 bg-neutral-50 p-3 text-sm">
            <span className="text-neutral-600">{orderRef || "Amount"}</span>
            <span className="font-mono text-lg font-bold">₹{amount.toLocaleString("en-IN")}</span>
          </div>
        )}

        <div className="mt-4 overflow-hidden rounded-lg border border-neutral-200 bg-neutral-950 p-4">
          <img src={BRAND.upi.qr} alt="Scan to pay via UPI (PhonePe)" className="mx-auto max-h-72 w-auto rounded-md" data-testid="upi-qr-image" />
        </div>

        <div className="mt-4 flex items-center gap-2 rounded-md border border-neutral-200 bg-white p-3">
          <div className="min-w-0">
            <div className="text-xs uppercase tracking-widest text-neutral-500">UPI ID</div>
            <div className="truncate font-mono text-sm font-bold" data-testid="upi-id">{BRAND.upi.id}</div>
          </div>
          <button onClick={copyUpi} className="ml-auto inline-flex items-center gap-1 rounded-md bg-lime-400 px-3 py-2 text-xs font-bold text-neutral-950 hover:bg-lime-300" data-testid="upi-copy-btn">
            {copied ? <><CheckCircle2 size={14} /> Copied</> : <><Copy size={14} /> Copy</>}
          </button>
        </div>

        <button onClick={() => { onClose(); toast.success("Payment recorded — vendor notified"); }} className="btn-offset mt-4 w-full rounded-md bg-neutral-950 px-4 py-3 text-sm font-bold text-white hover:bg-neutral-800" data-testid="upi-mark-paid">
          I've paid — continue
        </button>
        <p className="mt-2 text-center text-xs text-neutral-500">Payment held in escrow. Released after you confirm delivery.</p>
      </div>
    </div>
  );
}
